import { DataSourceDefinition } from '../models/dataSource-definition.model'

export const DataSource: DataSourceDefinition = {
  DfrsData: {
    name: 'dfrs-data',
    permissions: [],
  },
  RcsData: {
    name: 'rcs-data',
    permissions: [],
  },
}
